import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  checkboxContainer: {
    outlineStyle: 'none',
  },
  labelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    fontSize: 16,
    fontWeight: '400',
    color: colors.newUI.therapist.textBlue100,
    marginLeft: 5,
  },
  checkboxBase: {
    height: 36,
    width: 36,
    borderRadius: 7,
    borderColor: 'transparent',
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  // unselected states
  default: {
    backgroundColor: colors.newUI.therapist.bgBlue10,
    borderColor: colors.newUI.therapist.blue60,
  },
  hovered: {
    backgroundColor: colors.newUI.therapist.blue20,
    borderColor: colors.newUI.therapist.blue60,
  },
  focused: {
    backgroundColor: colors.newUI.therapist.blue20,
    borderColor: colors.newUI.therapist.blue60,
  },

  // selected states
  defaultSelected: {
    backgroundColor: colors.newUI.therapist.blue60,
    borderColor: colors.newUI.therapist.blue60,
  },
  hoveredSelected: {
    backgroundColor: colors.newUI.therapist.blue50,
    borderColor: colors.newUI.therapist.blue60,
  },
  focusedSelected: {
    backgroundColor: colors.newUI.therapist.blue50,
    borderColor: colors.newUI.therapist.blue60,
  },

  // disabled states
  disabled: {
    backgroundColor: colors.newUI.therapist.grey20,
    borderColor: colors.newUI.therapist.grey60,
  },
  disabledSelected: {
    backgroundColor: colors.newUI.therapist.grey60,
    borderColor: colors.newUI.therapist.grey60,
  },

  // custom focus outline
  focusWrapper: {
    padding: 2,
    borderRadius: 9,
    borderWidth: 2,
    borderColor: 'transparent',
  },
  focusOutline: {
    borderColor: colors.newUI.therapist.blue50,
  },
});
